<template>
	<div v-loading="dataLoading" class="BaseHeadingSchedulePlanner">
		<div class="my-6">
			<section :class="checkGridCol">

				<div class="ns-grid-card">
					<div class="schedule-planner-card w-full">
						<!-- For SB Malaysia -->
						<div>
							<div class="mb-2">
								<p class="schedule-planner-label pb-2">Projected Transactions</p>
								<div class="flex items-center justify-around">
									<span class="label1"> <p class="text-sm text-grey pb-1">Total</p> {{schedulerSummaryData.total_forecasted_transactions}} </span>
									<span class="label2"> <p class="text-sm text-grey pb-1">Daily Avg</p> {{schedulerSummaryData.projected_adt}} </span>
								</div>
							</div>
							<div class="mt-1">
								<p class="schedule-planner-label pb-2">Adjusted Transactions</p>
								<div class="flex items-center justify-around">
									<span class="label1"> <p class="text-sm text-grey pb-1">Total</p> {{ schedulerSummaryData.total_adjusted_transactions }} </span>
									<span class="label2"> <p class="text-sm text-grey pb-1">Daily Avg</p> {{ schedulerSummaryData.adjusted_adt }} </span>
								</div>
							</div>
						</div>
						<!-- For SB Malaysia -->

						<!-- <div v-else>
							<p v-if="checkCompany.is_mcd_north" class="schedule-planner-label pb-2">
								{{ schedulerSummaryData.projected_transaction ? 'Projected Transaction' : 'Projected GC' }}
							</p>
							<p v-else class="schedule-planner-label pb-2">{{ schedulerSummaryData.projected_transaction ?
								'Projected Transaction' : 'Projected Transactions' }}</p>
								
							<span class="label1 font-semibold">{{ schedulerSummaryData.projected_transaction ?
								schedulerSummaryData.projected_transaction : schedulerSummaryData.projected_adt }}</span>
						</div> -->

						<div style="display: none">
							<p class="text-sm text-grey p-2">Schedule | Ideal</p>
							<p></p>

							<div class="flex justify-around">
								<div>
									<p class="text-sm text-grey pb-2">Management</p>
									<p class="schedule-planner-value-child font-medium"><!----><span
											class="label1 font-medium">
											{{ schedulerSummaryData.retail_management_planned_labour_hours }}
										</span><span class="font-medium" style="color: rgb(51, 51, 51);"> |
										</span><!----><span class="label2 font-medium">
											{{ schedulerSummaryData.retail_management_projected_labour_hours }}
										</span></p>
								</div>
								<div>
									<p class="text-sm text-grey pb-2">Crew</p>
									<p class="schedule-planner-value-child font-medium"><!----><span
											class="label1 font-medium">
											{{ schedulerSummaryData.barista_planned_labour_hours }}
										</span><span class="font-medium" style="color: rgb(51, 51, 51);"> |
										</span><!----><span class="label2 font-medium">
											{{ schedulerSummaryData.barista_projected_labour_hours }}
										</span></p>
								</div>
							</div>
						</div>

					</div>
				</div>

				<!-- For CPRL only -->
				<div v-if="checkCompany.is_mcd_north" class="ns-grid-card">
					<div class="schedule-planner-card w-full">
						<p class="schedule-planner-label pb-2">Labor Hours (Crew)</p>
						<!-- projected_adt -->
						<!-- <span class="text-grey p-2"></span> -->
						<div>
							<span
								class="label1 font-semibold">{{ schedulerSummaryData.department_wise_values[1].total_scheduled_labour_hours }}</span>
							<span> | </span>
							<span
								class="label2 font-semibold">{{ schedulerSummaryData.department_wise_values[1].total_ideal_labour_hours }}</span>
						</div>

						<p class="text-sm text-grey p-2">Schedule | Ideal</p>
						<p></p>

						<div style="visibility: hidden" class="flex justify-around">
							<div v-for="(dept, index) in schedulerSummaryData.department_wise_values" :key="index">
								<p class="text-sm text-grey pb-2">{{ dept.name }}</p>
								<p class="schedule-planner-value-child font-medium"><!----><span class="label1 font-medium">
										{{ dept.total_scheduled_labour_hours }}
									</span><span class="font-medium" style="color: rgb(51, 51, 51);"> | </span><!----><span
										class="label2 font-medium">
										{{ dept.total_ideal_labour_hours }}
									</span></p>
							</div>
						</div>

					</div>
				</div>
				<!-- For CPRL only -->
				<div v-else class="ns-grid-card">
					<div class="schedule-planner-card w-full">
						<p class="schedule-planner-label pb-2">Labor Hours</p>
						<!-- projected_adt -->
						<!-- <span class="text-grey p-2"></span> -->
						<span class="label1 font-semibold">{{ schedulerSummaryData.total_scheduled_labour_hours }}</span>
						<span> | </span>
						<span class="label2 font-semibold">{{ schedulerSummaryData.total_ideal_labour_hours }}</span>

						<p class="text-sm text-grey p-2">Schedule | Ideal</p>
						<p></p>

						<div class="flex justify-around">
							<div v-for="(dept, index) in schedulerSummaryData.department_wise_values" :key="index">
								<p class="text-sm text-grey pb-2">{{ dept.name }}</p>
								<p class="schedule-planner-value-child font-medium"><!----><span class="label1 font-medium">
										{{ dept.total_scheduled_labour_hours }}
									</span><span class="font-medium" style="color: rgb(51, 51, 51);"> | </span><!----><span
										class="label2 font-medium">
										{{ dept.total_ideal_labour_hours }}
									</span></p>
							</div>
						</div>

					</div>
				</div>

				<!-- For SBMY only -->
				<div class="ns-grid-card">
					<div class="schedule-planner-card w-full relative">

						<el-dropdown class="ns-plh-sel" @command="handleWFData">
							<span class="el-dropdown-link">
								<i class="el-icon-caret-bottom ns-sum-icon-2"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="TPLH" :disabled="selected_plh_data.name === 'TPLH'">TPLH</el-dropdown-item>
								<el-dropdown-item command="IPLH" :disabled="selected_plh_data.name === 'IPLH'">IPLH</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown> 


						<p class="schedule-planner-label pb-2">{{ selected_plh_data.name }}</p>
						<!-- projected_adt -->
						<!-- <span class="text-grey p-2"></span> -->
						<!-- <span class="label1">{{ '0' }}</span> -->

						<div class="flex justify-around mt-6">
							<div>
								<p class="text-sm text-grey pb-2">Schedule</p>
								<p class="schedule-planner-value-child font-medium"><!----><span class="label1 font-semibold text-lg">
										{{ selected_plh_data.schedule }}
									</span>
								</p>
							</div>
							<div>
								<p class="text-sm text-grey pb-2">Actual</p>
								<p class="schedule-planner-value-child font-medium"><!----><span class="label1 font-semibold text-lg">
										{{ selected_plh_data.ideal }}
									</span>
								</p>
							</div>
						</div>

					</div>
				</div>
				<!-- For SBMY only -->

				<div class="ns-grid-card">
					<div class="schedule-planner-card w-full">
						<p class="schedule-planner-label pb-2">Labor Cost</p>
						<!-- projected_adt -->
						<!-- <span class="text-grey p-2"></span> -->
						<span class="label1 font-semibold"> {{ schedulerSummaryData.total_scheduled_labour_cost }} </span>
						<span> | </span>
						<span class="label2 font-semibold"> {{ schedulerSummaryData.total_actual_labour_cost  }} </span>

						<p class="text-sm text-grey p-2">Schedule | Actual</p>
						<p></p>

						<div class="flex justify-around">
							<div v-for="(dept, index) in schedulerSummaryData.department_wise_values" :key="index">
								<p class="text-sm text-grey pb-2">{{ dept.name }}</p>
								<p class="schedule-planner-value-child font-medium">
									<span class="label1 font-medium">
										{{ dept.total_scheduled_labour_cost }}
									</span><span class="font-medium" style="color: rgb(51, 51, 51);"> | </span>
									<span
										class="label2 font-medium">
										{{ dept.total_actual_labour_cost }}
									</span></p>
							</div>
						</div>

					</div>
				</div>

				<div class="ns-grid-card">
					<div class="schedule-planner-card w-full">
						<p class="schedule-planner-label pb-2">Workforce (FTE)</p>
						<span class="label1 font-semibold">{{ schedulerSummaryData.total_scheduled_manpower }}</span>
						<span> | </span>
						<span class="label2 font-semibold">{{ schedulerSummaryData.total_ideal_manpower }}</span>

						<p class="text-sm text-grey p-2">Schedule | Ideal</p>
						<p></p>

						<div class="flex justify-around">
							<div v-for="(dept, index) in schedulerSummaryData.department_wise_values" :key="index">
								<p class="text-sm text-grey pb-2">{{ dept.name }}</p>
								<p class="schedule-planner-value-child font-medium">
									<span class="label1 font-medium">
										{{ dept.total_scheduled_manpower }}
									</span><span class="font-medium" style="color: rgb(51, 51, 51);"> | </span>
									<span
										class="label2 font-medium">
										{{ dept.total_ideal_manpower }}
									</span></p>
							</div>
						</div>

					</div>
				</div>

			</section>
		</div>
	</div>
</template>
<script>

export default {
	name: "BaseHeadingSchedulePlanner",
	props: {
		headingSchedulerTableData: {
			type: Array,
			default: () => []
		},
		eventList: {
			type: Array,
			default: () => []
		},
		schedulerSummaryData: {
			type: Object,
			default: () => { }
		},
		dataLoading: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			colWidth: 6,
			selected_plh_data: {
				name: 'IPLH',
				schedule: this.schedulerSummaryData.scheduled_iplh,
				ideal: this.schedulerSummaryData.actual_iplh,
			},
		};
	},
	computed: {
		is_SB_malaysia() {
			return localStorage.getItem('company_id') == '15e1f09e-acdb-43de-8009-db3e1bb5c1a1' ? true : false;;
		},
		is_BkAsia() {
			let result = false;
			let check_mail = localStorage.getItem('user_email');
			if (check_mail == 'bkasia@nymbleup.com') {
				result = true;
			}
			return result;
		},
		checkCompany() {
			let conditions = JSON.parse(localStorage.getItem('check_company'));
			return conditions ? conditions : {};
		},
		checkGridCol() {
			return 'ns-grid-container';
		}
	},
	watch:{
		schedulerSummaryData:{
			handler(val){
				if(this.checkCompany.is_sb_malaysia){
					this.selected_plh_data.name = 'IPLH';
					this.selected_plh_data.schedule = this.schedulerSummaryData.scheduled_iplh;
					this.selected_plh_data.ideal = this.schedulerSummaryData.actual_iplh;
				} else {
					this.selected_plh_data.name = 'TPLH';
					this.selected_plh_data.schedule = this.schedulerSummaryData.scheduled_tplh;
					this.selected_plh_data.ideal = this.schedulerSummaryData.actual_tplh;
				}
			},
			deep:true
		}
	},
	mounted() {
		// if (this.checkCompany.is_sb_malaysia) {
		// } else {
		// 	this.colWidth = 6;
		// }
		// this.colWidth = 6;
	},
	methods: {
		handleWFData(cmd){
			if(cmd === 'TPLH'){
				this.selected_plh_data.name = 'TPLH';
				this.selected_plh_data.schedule = this.schedulerSummaryData.scheduled_tplh;
				this.selected_plh_data.ideal = this.schedulerSummaryData.actual_tplh;
			}else if(cmd === 'IPLH'){
				this.selected_plh_data.name = 'IPLH';
				this.selected_plh_data.schedule = this.schedulerSummaryData.scheduled_iplh;
				this.selected_plh_data.ideal = this.schedulerSummaryData.actual_iplh;
			}
		}
	},
};
</script>
<style lang="scss">@import "./BaseHeadingSchedulePlanner";</style>
